export function createDirection(
  from: string | undefined,
  to: string | undefined,
  relatedAddresses: Set<string>,
): 'in' | 'out' | 'none' {
  if (
    from !== undefined &&
    relatedAddresses.has(from) &&
    (to === undefined || !relatedAddresses.has(to))
  ) {
    return 'out'
  }
  if (
    to !== undefined &&
    relatedAddresses.has(to) &&
    (from === undefined || !relatedAddresses.has(from))
  ) {
    return 'in'
  }
  return 'none'
}
